import { localizedProductsPath } from './localized-paths';

/** Categories have language-neutral IDs, unlike translated product slugs.
 * Recognize them before the header attempts a product-slug lookup.
 */
export function categoryLanguageSwitchUrl(url: URL, locale: string): string | null {
  const path = url.pathname.replace(/^\/(nl|de|en|fr|da|it|es|pl|pt|cs)(?=\/|$)/, '');
  const match = path.match(/^\/(?:producten|produkte|products|produits)\/(?:categorie|kategorie|category)\/([^/]+)\/?$/);
  if (!match) return null;
  let category: string;
  try {
    category = decodeURIComponent(match[1]);
  } catch {
    return null;
  }
  return `${localizedProductsPath(locale, { category })}${url.search}${url.hash}`;
}
